import create from 'zustand';

interface AppState {
  loading: boolean;
  message: string;
  startLoading: (message?: string) => void;
  finishLoading: () => void;
}

const useLoading = create<AppState>((set) => ({
  loading: false,
  message: '',
  startLoading: (message = 'Vui lòng đợi trong giây lát') => set({ loading: true, message }),
  finishLoading: () => set({ loading: false, message:'' }),
}));

export default useLoading;
